import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { DependentsContext } from '#providers/dependents/Dependents.context.ts';
import type { TDependentsContextValue } from '#providers/dependents/Dependents.types.ts';

export const useDependents = (): TDependentsContextValue =>
  useRequiredContext(
    DependentsContext,
    'useDependents is only available inside a DependentsProvider',
  );
